import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import '../../../../assets/css/user/home/subscreens/blogs/Blogs.css';
import AppContext from '../../../../context/AppContext';
import axios from 'axios';



const BlogSection = () => {
  const navigate = useNavigate();
  const [blogsData, setBlogsData] = useState([]);
  const { baseUrl, baseUrlForFile } = useContext(AppContext);
  const [activeCard, setActiveCard] = useState(0);


  const fetchAllBlogs = () => {
    axios
      .get(`${baseUrl}/customer/blogs/fetchAllBlogs`)
      .then((res) => {
        console.log(res.data);
        if (res.data.success == true) {
          setBlogsData(res.data.blogs);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    console.log("log from the blog data");
    fetchAllBlogs();
  }, []);

  useEffect(() => {
    if (blogsData.length === 0) return;
    const interval = setInterval(() => {
      setActiveCard((prev) => (prev + 1) % blogsData.length);
    }, 3500);
    return () => clearInterval(interval);
  }, [blogsData.length]);

  const getCardPosition = (index) => {
    const diff = (index - activeCard + blogsData.length) % blogsData.length;
    if (diff === 0) return 'center';
    if (diff === 1) return 'right';
    if (diff === blogsData.length - 1) return 'left';
    return null;
  };

  return (
    <div className='container'>
      <section className="bs-section">

        {/* Blobs */}
        <div className="bs-blob bs-blob-1" />
        <div className="bs-blob bs-blob-2" />

        {/* Bubbles — now full section width */}
        <div className="bs-bubbles-container">
          <div className="bs-bubble bs-b1" />
          <div className="bs-bubble bs-b2" />
          <div className="bs-bubble bs-b3" />
          <div className="bs-bubble bs-b4" />
          <div className="bs-bubble bs-b5" />
          <div className="bs-bubble bs-b6" />
          <div className="bs-bubble bs-b7" />
          <div className="bs-bubble bs-b8" />
          <div className="bs-bubble bs-b9" />
        </div>

        <Container fluid className="bs-container">

          {/* ── LATEST NEWS HEADING — TOP ── */}
          <div className="bs-latest-news-wrapper">
            <div className="bs-latest-news-label">
              <span className="bs-latest-news-line" />
              <span className="bs-latest-news-eyebrow">Latest News</span>
              <span className="bs-latest-news-line" />
            </div>
            <h2 className="bs-latest-news-title">
              What's New in <span>AgriRent</span>
            </h2>
          </div>

          <Row className="bs-row align-items-center">

            {/* LEFT */}
            <Col xs={12} lg={5} className="bs-left-col">
              <div className="bs-left-content">
                <div className="bs-eyebrow">
                  <span className="bs-eyebrow-line" />
                  <span className="bs-eyebrow-text">Our Blog</span>
                </div>
                <h2 className="bs-heading">
                  Insights for the{' '}
                  <span className="bs-heading-highlight">Modern Farmer</span>
                </h2>
                <p className="bs-description">
                  Stay updated with practical tips on equipment rental, maintenance, and modern farming techniques. Our insights help farmers make smarter decisions, improve productivity, and manage resources efficiently in every season.
                </p>
                <button className="bs-view-btn" onClick={() => navigate('/blog')}>
                  <span>View More Blogs</span>
                  <FaArrowRight className="bs-btn-icon" />
                </button>
              </div>
            </Col>

            {/* RIGHT */}
            <Col xs={12} lg={7} className="bs-right-col">
              <div className="bs-carousel-outer">
                <div className="bs-carousel-wrapper">
                  <div className="bs-fade-top" />
                  <div className="bs-fade-bottom" />
                  <div className="bs-carousel">
                    {blogsData.map((card, index) => {
                      const position = getCardPosition(index);
                      if (!position) return null;
                      return (
                        <div
                          key={card.id}
                          className={`bs-card-wrapper ${position}`}
                          onClick={() => setActiveCard(index)}
                        >
                          <div className={`bs-card ${position === 'center' ? 'active' : ''}`}>
                            <div className="bs-card-image-wrapper">
                              <img
                                src={`${baseUrlForFile}/${card.image}`}
                                alt={card.title}
                                className="bs-card-image"
                              />
                            </div>
                            <div className="bs-card-body">
                              <h4 className="bs-card-heading">{card.title}</h4>
                              <p className="bs-card-description">{card.description}</p>
                            </div>

                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                {/* Pagination */}
                <div className="bs-pagination">
                  {blogsData.map((_, i) => (
                    <span
                      key={i}
                      className={`bs-dot ${activeCard === i ? 'active-dot' : ''}`}
                      onClick={() => setActiveCard(i)}
                    />
                  ))}
                </div>
              </div>
            </Col>

          </Row>
        </Container>
      </section>
    </div>
  );
};

export default BlogSection;